export default class PageAccessService {
    constructor($sbExternalService) {
        "ngInject";

        this.$sbExternalService = $sbExternalService;
    }

    get angularPageAccessService() {
        return this.$sbExternalService?.pageAccessService?.();
    }

    registerState(state, requiredFeature, requiredFeaturePackage) {
        const service = this.angularPageAccessService;
        if (!service) {
            throw new Error(
                "PageAccessService is not available in the current environment"
            );
        }
        return service.registerState(
            state,
            requiredFeature,
            requiredFeaturePackage
        );
    }

    isAccessible(state, withPrivilege) {
        const service = this.angularPageAccessService;
        if (!service) {
            return false;
        }
        return service.isAccessible(state, withPrivilege);
    }

    isPrivilegeGranted(privilege, feature) {
        const service = this.angularPageAccessService;
        if (!service) {
            return false;
        }
        return service.isPrivilegeGranted(privilege, feature);
    }
}
